import { useItem } from './hooks/use-context';

export function CausesAnalysis() {
  const { sections } = useItem();
  const questions = sections.flatMap((section) => section.questions);

  const getAnswerByText = (text: string) => {
    const q = questions.find((q) => q.name.toLowerCase().includes(text.toLowerCase()));
    if (!q || !q.answers || q.answers.length === 0) return '';
    return q.answers[0].content || q.answers[0].option;
  };

  const p1 = getAnswerByText('O que aconteceu?');
  const p2 = getAnswerByText('Como aconteceu?');
  const p3 = getAnswerByText('Quais as falhas identificadas?');
  const p4 = getAnswerByText('O que facilitou para o acontecimento?');
  const p5 = getAnswerByText('O que evitaria o evento?');
  const arvoreDeCausa = getAnswerByText('Arvore de Causa') || getAnswerByText('Árvore de Causa');

  const rowStyle = { borderBottom: '1px solid #000', display: 'flex' };
  const numStyle = { width: '30px', padding: '4px', borderRight: '1px solid #000', textAlign: 'center' as const };
  const questionStyle = { width: '220px', padding: '4px', borderRight: '1px solid #000' };
  const answerStyle = { flex: 1, padding: '4px' };

  return (
    <div style={{ color: '#000', fontSize: '13px', lineHeight: '1.5', fontFamily: 'sans-serif', breakInside: 'avoid' }}>
      <div style={{ backgroundColor: '#D9D9D9', padding: '4px', fontWeight: 'bold', marginBottom: '16px', fontSize: '14px' }}>
        2- ANÁLISE DAS CAUSAS
      </div>
      
      <div style={{ border: '1px solid #000', marginBottom: '24px' }}>
        <div style={{ borderBottom: '1px solid #000', padding: '4px', fontWeight: 'bold' }}>
          2.1 5 PORQUÊS
        </div>
        
        <div style={rowStyle}>
          <div style={numStyle}>01</div>
          <div style={questionStyle}>O que aconteceu?</div>
          <div style={answerStyle}>{p1}</div>
        </div>
        <div style={rowStyle}>
          <div style={numStyle}>02</div>
          <div style={questionStyle}>Como aconteceu?</div>
          <div style={answerStyle}>{p2}</div>
        </div>
        <div style={rowStyle}>
          <div style={numStyle}>03</div>
          <div style={questionStyle}>Quais as falhas identificadas?</div>
          <div style={answerStyle}>{p3}</div>
        </div>
        <div style={rowStyle}>
          <div style={numStyle}>04</div>
          <div style={questionStyle}>O que facilitou para o acontecimento?</div>
          <div style={answerStyle}>{p4}</div>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={numStyle}>05</div>
          <div style={questionStyle}>O que evitaria o evento?</div>
          <div style={answerStyle}>{p5}</div>
        </div>
      </div>

      <div style={{ border: '1px solid #000', marginBottom: '24px' }}>
        <div style={{ borderBottom: '1px solid #000', padding: '4px', fontWeight: 'bold' }}>
          2.2 ARVORE DE CAUSA
        </div>
        <div style={{ padding: '8px', minHeight: '150px' }}>
          {arvoreDeCausa}
        </div>
      </div>
    </div>
  );
}
